<div
	#elementContainer
	[style.top]="elementStyleTop"
	[style.bottom]="elementStyleBottom"
	[style.transition]="'top 0.3s ease-out'"
	[style.position]="'fixed'"
	[style.zIndex]="1"
>
	<ng-content></ng-content>
</div>
